export default "__VITE_ASSET__B18AwwMT__"